// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_ConfirmExitReportResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for PUT /so/orders/confirm_exit_report
 *
 * Returns the exit report id and a confirmation flag.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_ConfirmExitReportResponseDados {
report_id: number
confirmed: boolean
}

export type Orders_ConfirmExitReportResponse = ApiResponse<Orders_ConfirmExitReportResponseDados>;

registerResponseContract('Orders_ConfirmExitReportResponse', {
  report_id: { type: 'number',  required: true },
  confirmed: { type: 'boolean', required: true },
})
